import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Container } from 'react-bootstrap';
import DealerBlacklistForm from './DealerBlacklistForm';
import DealerBlacklistTable from './DealerBlacklistTable';
import PageBreadcrumb from '../../common/components/layout/PageBreadcrumb';
import { setQueryString, useQueryString } from '../../common/helpers/queryString';
import { searchBlacklistDealers } from '../DealersActions';
import { PrepareUrl } from '../../common/helpers/PrepareUrl';
import RouterPaths from '../../constants/RouterPaths';

function DealerBlacklistPage() {
  const { id } = useParams();
  const query = useQueryString();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const items = useSelector((state) => state.dealers.get('items'));
  const totalItems = useSelector((state) => state.dealers.get('totalItems'));

  const [searchParams, setSearchParams] = useState({
    offset: query.get('page') ? +query.get('page') - 1 : 0,
  });

  useEffect(() => {
    dispatch(searchBlacklistDealers(searchParams, id));
  }, [dispatch, searchParams, id]);

  const changeOffset = (value) => {
    setSearchParams((prevState) => ({ ...prevState, offset: value }));
    navigate(setQueryString(location, 'page', value + 1));
  };

  const breadcrumbs = [
    { id: 1, type: 'home' },
    { id: 2, type: 'link', text: 'Dealers', url: '/dealers' },
    {
      id: 3,
      type: 'link',
      text: 'Edit Dealer',
      url: PrepareUrl(RouterPaths.DEALER_INFORMATION, { id }),
    },
    { id: 4, type: 'span', text: 'Blacklist' },
  ];

  return (
    <Container fluid>
      <PageBreadcrumb items={breadcrumbs} pageTitle="Blacklist" />
      <DealerBlacklistForm searchParams={searchParams} dealers={items} />
      <DealerBlacklistTable
        data={{ items, total: totalItems }}
        offset={searchParams.offset}
        changeOffset={changeOffset}
        searchParams={searchParams}
      />
    </Container>
  );
}

export default DealerBlacklistPage;
